<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col">
        <div class="card card-default">
          <div class="card-header">Account settings</div>
          <div class="card-body">
            <h6>Profile details</h6>
            <div class="row">
              <div class="col-md-6 offset-md-4">
                <div v-if="error.profile" class="alert alert-danger">{{ error.profile }}</div>
                <div v-if="message.profile" class="alert alert-success">{{ message.profile }}</div>
              </div>
            </div>
            <div class="form-group row">
              <label for="name" class="col-md-4 col-form-label text-md-right">Name</label>

              <div class="col-md-6">
                <input id="name" v-model="form.profile.name" :class="{ 'is-invalid': errors.profile.name }" type="text" class="form-control" required>
                <span v-if="errors.profile.name" class="invalid-feedback">
                  <div v-for="(error, index) in errors.profile.name" :key="index"><strong>{{ error }}</strong></div>
                </span>
              </div>
            </div>

            <div class="form-group row mb-0">
              <div class="col-md-6 offset-md-4 text-center">
                <button type="submit" class="btn btn-primary" @click.prevent="submitProfile()">
                  <span v-if="this.$loading.isLoading('profile-update')"><i class="pe pe-spinner fa-spin" aria-hidden="true"/></span> Update
                </button>
              </div>
            </div>
            <hr class="separator">
            <h6>Update email address</h6>
            <div class="row">
              <div class="col-md-6 offset-md-4">
                <div v-if="error.email" class="alert alert-danger">{{ error.email }}</div>
                <div v-if="message.email" class="alert alert-success">{{ message.email }}</div>
              </div>
            </div>
            <div class="form-group row">
              <label for="email" class="col-md-4 col-form-label text-md-right">E-mail</label>

              <div class="col-md-6">
                <input id="email" v-model="form.email.email" :class="{ 'is-invalid': errors.email.email }" type="email" class="form-control" required>
                <span v-if="errors.email.email" class="invalid-feedback">
                  <div v-for="(error, index) in errors.email.email" :key="index"><strong>{{ error }}</strong></div>
                </span>
              </div>
            </div>

            <div class="form-group row">
              <label for="password" class="col-md-4 col-form-label text-md-right">Password</label>

              <div class="col-md-6">
                <input id="password" v-model="form.email.password" :class="{ 'is-invalid': errors.email.password }" type="password" class="form-control" required>
                <span v-if="errors.email.password" class="invalid-feedback">
                  <div v-for="(error, index) in errors.email.password" :key="index"><strong>{{ error }}</strong></div>
                </span>
                <span class="feedback"><i class="pe pe-info" aria-hidden="true"/><span class="inline-text">To update the email address please enter your account password</span></span>
              </div>
            </div>

            <div class="form-group row mb-0">
              <div class="col-md-6 offset-md-4 text-center">
                <button type="submit" class="btn btn-primary" @click.prevent="submitEmail()">
                  <span v-if="this.$loading.isLoading('email-update')"><i class="pe pe-spinner fa-spin" aria-hidden="true"/></span> Update
                </button>
              </div>
            </div>
            <hr class="separator">
            <h6>Update password</h6>
            <div class="row">
              <div class="col-md-6 offset-md-4">
                <div v-if="error.auth" class="alert alert-danger">{{ error.auth }}</div>
                <div v-if="message.auth" class="alert alert-success">{{ message.auth }}</div>
              </div>
            </div>
            <div class="form-group row">
              <label for="current-password" class="col-md-4 col-form-label text-md-right">Current password</label>

              <div class="col-md-6">
                <input id="current-password" v-model="form.auth.currentPassword" :class="{ 'is-invalid': errors.auth.currentPassword }" type="password" class="form-control" required>
                <span v-if="errors.auth.currentPassword" class="invalid-feedback">
                  <div v-for="(error, index) in errors.auth.currentPassword" :key="index"><strong>{{ error }}</strong></div>
                </span>
              </div>
            </div>
            <div class="form-group row">
              <label for="new-password" class="col-md-4 col-form-label text-md-right">New password</label>

              <div class="col-md-6">
                <input id="new-password" v-model="form.auth.newPassword" :class="{ 'is-invalid': errors.auth.newPassword }" type="password" class="form-control" required>
                <span v-if="errors.auth.newPassword" class="invalid-feedback">
                  <div v-for="(error, index) in errors.auth.newPassword" :key="index"><strong>{{ error }}</strong></div>
                </span>
              </div>
            </div>
            <div class="form-group row">
              <label for="new-password" class="col-md-4 col-form-label text-md-right">New password confirm</label>

              <div class="col-md-6">
                <input id="new-password-confirm" v-model="form.auth.newPasswordConfirm" :class="{ 'is-invalid': errors.auth.newPasswordConfirm }" type="password" class="form-control" required>
                <span v-if="errors.auth.newPasswordConfirm" class="invalid-feedback">
                  <div v-for="(error, index) in errors.auth.newPasswordConfirm" :key="index"><strong>{{ error }}</strong></div>
                </span>
              </div>
            </div>

            <div class="form-group row mb-0">
              <div class="col-md-6 offset-md-4 text-center">
                <button type="submit" class="btn btn-primary" @click.prevent="submitPassword()">
                  <span v-if="this.$loading.isLoading('password-update')"><i class="pe pe-spinner fa-spin" aria-hidden="true"/></span> Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'AccountSettings',
  data () {
    return {
      message: {
        profile: '',
        email: '',
        auth: ''
      },
      error: {
        profile: '',
        email: '',
        auth: ''
      },
      errors: {
        profile: {},
        email: {},
        auth: {}
      },
      form: {
        profile: {
          name: ''
        },
        email: {
          email: '',
          password: ''
        },
        auth: {
          currentPassword: '',
          newPassword: '',
          newPasswordConfirm: ''
        }
      }
    }
  },
  computed: {
    ...mapState({
      state: state => state
    })
  },
  mounted () {
    if (!this.state.account.me) {
      this.$loading.startLoading('fetching-data-from-backend')
      this.$store.dispatch('getLoggedInUser').then(() => {
        this.form.profile.name = this.state.account.me.name
        this.form.email.email = this.state.account.me.email
        this.$loading.endLoading('fetching-data-from-backend')
      }).catch(() => {
        this.$loading.endLoading('fetching-data-from-backend')
      })
    } else {
      this.form.profile.name = this.state.account.me.name
      this.form.email.email = this.state.account.me.email
    }
  },
  methods: {
    ...mapActions([
      'updateProfile',
      'updateEmail',
      'updatePassword'
    ]),
    submitProfile () {
      this.$loading.startLoading('profile-update')
      this.errors.profile = {}
      this.updateProfile(this.form.profile)
        .then((data) => {
          this.error.profile = ''
          this.message.profile = data.message
          this.$loading.endLoading('profile-update')
        })
        .catch((data) => {
          this.message.profile = ''
          this.error.profile = data.message
          this.errors.profile = data.errors || {}
          this.$loading.endLoading('profile-update')
        })
    },
    submitEmail () {
      this.$loading.startLoading('email-update')
      this.errors.email = {}
      this.updateEmail(this.form.email)
        .then((data) => {
          this.error.email = ''
          this.form.email.password = ''
          this.message.email = data.message
          this.$loading.endLoading('email-update')
        })
        .catch((data) => {
          this.message.email = ''
          this.error.email = data.message
          this.errors.email = data.errors || {}
          this.$loading.endLoading('email-update')
        })
    },
    submitPassword () {
      this.$loading.startLoading('password-update')
      this.errors.auth = {}
      this.updatePassword(this.form.auth)
        .then((data) => {
          this.error.auth = ''
          this.form.auth.currentPassword = ''
          this.form.auth.newPassword = ''
          this.form.auth.newPasswordConfirm = ''
          this.message.auth = data.message
          this.$loading.endLoading('password-update')
        })
        .catch((data) => {
          this.message.auth = ''
          this.error.auth = data.message
          this.errors.auth = data.errors || {}
          this.$loading.endLoading('password-update')
        })
    }
  }
}
</script>
